class SomeonePurchase extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        
        if (this.popup.getElementsByClassName('data-product').length == 0) return;

        this.time = this.popup.getAttribute('data-notification-time');

        if (this.getCookie('notification-popup') === ''){
            var initSomeonePurchasePopup = this.initSomeonePurchasePopup,
                popup = this.popup;

            var timer = setInterval(function() {
                if(popup.innerHTML.length > 0){
                    initSomeonePurchasePopup(popup);
                }
            }, this.time);
        } else {
            this.deleteCookie('notification-popup');
            this.remove();
        }

        this.querySelector('[data-close-notification-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        
        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup(expiresDate = 1) {
        this.setCookie('notification-popup', 'closed', expiresDate);

        this.popup.classList.remove('is-active');
        this.popup.remove();
    }

    initSomeonePurchasePopup(popup) {
    if (popup.classList.contains('is-active')) {
        popup.classList.remove('is-active');
    } else {
        const product       = popup.getElementsByClassName('data-product');
        const popupImage    = popup.getElementsByClassName('product-image');
        const productLength = product.length;
        const i             = Math.floor(Math.random() * productLength);
        const productItem   = product[i];

        const image = productItem.getAttribute('data-image');
        const title = productItem.getAttribute('data-title');   // real product title
        const url   = productItem.getAttribute('data-url');

        // ——————————————————————————————————————
        // POPUP-ONLY TITLE — ONLY CHANGES THE NOTIFICATION
        let popupTitle = title; // fallback to real title

        // ←←← UNCOMMENT ONLY ONE OF THESE LINES:
        // popupTitle = '16" Adjustable Rolling Pin';
        // popupTitle = 'Birchberry Adjustable Rolling Pin';
        popupTitle = '16" Birchberry Rolling Pin';   // ← this one converts the best
        // ——————————————————————————————————————

        const locals      = popup.getElementsByClassName('data-local');
        const localLength = locals.length;
        const j           = Math.floor(Math.random() * localLength);
        const local       = locals[j].getAttribute('data-local');

        const times       = popup.getElementsByClassName('data-time');
        const timeLength  = times.length;
        const k           = Math.floor(Math.random() * timeLength);
        const time        = times[k].getAttribute('data-time');

        popup.classList.add('is-active');

        // Image
        popupImage[0].setAttribute('href', url);
        popupImage[0].innerHTML = `<img src="${image}" alt="${popupTitle}" title="${popupTitle}"><svg role="img" ...></svg>`; // (keep your full SVG code here)

        // Full sentence
        const timeText = popup.querySelector('[data-time-text]');

        const productLink = document.createElement('a');
        productLink.href = url;
        productLink.className = 'product-name link-underline';
        productLink.style.display = 'inline';
        productLink.textContent = popupTitle;           // ← uses the custom title

            // Main sentence (without the time)
        timeText.innerHTML = `
            ${timeText.dataset.someone}
            in <strong>${local}</strong>
            ${timeText.dataset.justBought}
            ${productLink.outerHTML}
        `.replace(/\s+/g, ' ').trim();

        // Add the time on its own line inside a span with a class
        const timeSpan = document.createElement('span');
        timeSpan.className = 'notification-time';
        timeSpan.textContent = `${time} ${timeText.dataset.ago}`;
        timeText.appendChild(timeSpan);
            }
        }
}

customElements.define('notification-popup', SomeonePurchase);